export class Node {
    constructor(x, y, index) {
      this.x = x;
      this.y = y;
      this.index = index;
    }
  }